module.exports = "files/mushroomMarioHit.mp3";